import useIsNewAppShell from '@/common/hooks/useIsNewAppShell';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useEffect, useState } from 'react';

export const NATIVE_DOCTOR_PANEL_FEATURE = 'native-doctor-panel';
const DEBUG_KEY = 'debug:native-doctor-panel';

/**
 * The native (non-iframe) doctor panel pages are on for the latest app (version_code ≥ 9100) AND only for users
 * the GrowthBook flag `native-doctor-panel` targets. Everyone else keeps the providers.paziresh24.com iframe.
 * Dev-only: native is ON by default in a normal browser tab; `?native_panel=0` turns it off (stored in localStorage), `=1` back on.
 */
export const useNativeDoctorPanelState = () => {
  const isNewApp = useIsNewAppShell();
  const flagOn = useFeatureIsOn(NATIVE_DOCTOR_PANEL_FEATURE);
  const [debug, setDebug] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      setReady(true);
      return;
    }
    try {
      const q = /[?&]native_panel=([01])/.exec(window.location.search);
      if (q) window.localStorage.setItem(DEBUG_KEY, q[1]);
      setDebug(window.localStorage.getItem(DEBUG_KEY) !== '0');
    } catch {
      /* storage blocked */
    }
    setReady(true);
  }, []);

  return { native: (isNewApp && flagOn) || debug, ready };
};

export const useNativeDoctorPanel = () => useNativeDoctorPanelState().native;
